import React from "react"

import { APP_PAGE_URL } from "utils/env-management"

export function RecommendToEmployerBanner({ className }: { className?: string }) {
    return (
        <div className={className}>
            <a
                href={`${APP_PAGE_URL}/goodplan`}
                target="_blank"
                rel="noopener noreferrer"
                className="b2b-banner"
            >
                <div>
                    <div className="b2b-banner__headline">Как платить за&nbsp;терапию меньше?</div>
                    <div className="b2b-banner__text">
                        Порекомендуйте Alter работодателю и&nbsp;попросите оплачивать ваши сессии.
                    </div>
                    <div className="b2b-banner__link">Подробнее</div>
                </div>
            </a>
        </div>
    )
}
